<template>
<div>
  <el-button style="width:100%;" type="secondary" size="small" @click="open">이벤트/알람 설정</el-button>
  <w-sliding-popup type="full" ref="slidingPopup" :title="title" top="50px" width="800px" :appendToBody="true" @close="onClose">
    <div slot="content">
      <w-obj-event-alarm-set-table class="mr-b25" :obj="targetObj" :has-auth="hasAuth" :show-script-set="true" :table-height="showControlScript ? '500px' : null" @show-control-script="setControlScriptEventAlarmSetting" />
      <w-control-script-setting v-show="showControlScript" :obj="targetObj" :selected-event-alarm-rule="selectedEventAlarmSetting"></w-control-script-setting>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import WObjEventAlarmSetTable from '@/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/components/ObjEventAlarmSetTable';
import WControlScriptSetting from './ControlScriptSetting';

export default {
  name: 'WEventAlarmRulePopupButton',
  components: {
    WObjEventAlarmSetTable,
    WControlScriptSetting,
  },
  props: {
    objInfo: {
      type: Object,
      default: () => {},
    },
    hasAuth: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      targetObj: null,
      selectedEventAlarmSetting: null,
    };
  },
  computed: {
    /**
     * 이벤트/알람 정책 개별 설정 팝업 타이틀
     * @author Ju
     * @return {String}
     */
    title() {
      const title = '이벤트/알람 정책 개별 설정';
      return isNil(this.objInfo.label) ? title : `[${this.objInfo.label}] ${title}`;
    },
    /**
     * 제어 스크립트 제공 여부
     * @author Ju
     * @return {boolean}
     */
    showControlScript() {
      return !isNil(this.objInfo.obj) && (this.objInfo.obj.objtypeId !== 'WIRELESS_AP') && (this.objInfo.obj.objManagetypeId === 'NMS' || this.objInfo.obj.objManagetypeId === 'SMS') && this.hasAuth;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.targetObj = this.objInfo.obj;
      if (this.objInfo.obj.objManagetypeId === 'E2E') {
        this.targetObj.rsctypeKey = this.objInfo.rscKey;
      }
    },
    onClose() {
      this.targetObj = null;
    },
    /**
     * 이벤트/알람 제어 스크립트를
     * @author Ju
     * @param  {[type]} eventAlarmSetting [description]
     */
    setControlScriptEventAlarmSetting(eventAlarmSetting) {
      this.selectedEventAlarmSetting = eventAlarmSetting;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/EventAlarmRulePopupButton.vue